import React, { useState } from 'react';

// Small "i" icon that opens a styled OVR-themed popover with explanatory copy.
// Used for non-mandatory policy disclosures (e.g. cancellation policy) so we
// satisfy our due diligence without advertising the option to cancel.
export default function InfoIcon({ title, body, size = 14, color = '#9D1515' }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <button
        type="button"
        onClick={e => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
        aria-label={title}
        style={{
          width: size + 6, height: size + 6,
          borderRadius: '50%',
          border: `1px solid ${color}`,
          background: 'transparent',
          color,
          fontFamily: 'Georgia, serif',
          fontStyle: 'italic',
          fontSize: Math.round(size * 0.75),
          fontWeight: 700,
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          lineHeight: 1,
          flexShrink: 0,
        }}
      >
        i
      </button>
      {open && (
        <div
          onClick={close}
          style={{
            position: 'fixed', inset: 0, zIndex: 200,
            background: 'rgba(0,0,0,0.7)',
            backdropFilter: 'blur(4px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: 24,
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#0e0e0e',
              border: '1px solid #2a2a2a',
              borderLeft: `3px solid ${color}`,
              padding: 24,
              maxWidth: 440,
              width: '100%',
              color: '#fff',
              fontFamily: "'Inter', system-ui, sans-serif",
            }}
          >
            <div style={{
              fontFamily: "'Bebas Neue','Oswald',sans-serif",
              fontSize: 22, letterSpacing: '0.1em',
              marginBottom: 12, color: '#fff',
            }}>
              {title}
            </div>
            <p style={{
              fontSize: 13, lineHeight: 1.6,
              color: 'rgba(255,255,255,0.75)',
              margin: '0 0 18px',
            }}>
              {body}
            </p>
            <button
              type="button"
              onClick={close}
              style={{
                background: color, color: '#fff', border: 'none',
                fontFamily: "'Bebas Neue','Oswald',sans-serif",
                fontSize: 12, letterSpacing: '0.16em',
                padding: '8px 16px', cursor: 'pointer',
              }}
            >
              GOT IT
            </button>
          </div>
        </div>
      )}
    </>
  );
}
